function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M438.48 58.61a130.815 130.815 0 00-95.573-41.711 130.968 130.968 0 00-95.676 41.694l-8.431 8.909-8.431-8.909C181.282 5.762 98.659 2.728 45.829 51.815a130.901 130.901 0 00-6.778 6.778c-52.072 56.166-52.072 142.97 0 199.13l187.36 197.58c6.482 6.843 17.284 7.136 24.127.654.224-.212.442-.43.654-.654l187.29-197.58c52.068-56.16 52.068-142.96-.001-199.12z",
  fill: "#ff3945"
});

function SvgHeartFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 477.53 477.53"
  }, props), _ref);
}

export default SvgHeartFull;